export default __webpack_public_path__ + "static/media/create-trustline-step-1.89520e37.png";